function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  opacity: 0.7,
  d: "M6.777.657L4.005 3.604 1.233.657a.71.71 0 00-.23-.164.676.676 0 00-.777.164.799.799 0 000 1.07l3.279 3.486a.682.682 0 001.007 0l3.279-3.485a.798.798 0 000-1.07.696.696 0 00-1.014 0z",
  fill: "#70544F"
});
function SvgToggle1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgToggle1;